import React from 'react';
import { NavLink } from "react-router-dom"
const Learning_us_states = () => {
  return (
   <div className='fixed top-24 right-0 left-0  justify-items-stretch w-full  content-center items-center'>      
      <div className="h-24 grid grid-cols-5 flex bg-[#007bff]"> 
       <NavLink to="/learning/independentlearning_k13" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md ' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }
      >Independent Learning</NavLink>
               <NavLink to="/learning/prekindergartengrade_k0" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md ' // Inactive styles
        }
      >Pre-Kindergarten</NavLink>
               <NavLink to="/learning/kindergartengrade_k" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white ' // Inactive styles
        }
      >Kindergarten</NavLink>
               <NavLink to="/learning/firstgrade_k1" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md' // Inactive styles
        }
      >First Grade</NavLink>
               <NavLink to="/learning/secondgrade_k2" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md' // Inactive styles
        }
      >Second Grade</NavLink>
               <NavLink to="/learning/thirdgrade_k3" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md' // Inactive styles
        }
      >Third Grade</NavLink>
               <NavLink to="/learning/fourthgrade_k4" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white  rounded-md' // Inactive styles
        }
      >Fourth Grade</NavLink>
               <NavLink to="/learning/fifthgrade_k5" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white  rounded-md' // Inactive styles
        }
      >Fifth Grade</NavLink>
               <NavLink to="/learning/sixthgrade_k6" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white  rounded-md' // Inactive styles
        }
      >Sixth Grade</NavLink>
               <NavLink to="/learning/seventhgrade_k7" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white rounded-md' // Inactive styles
        }
      >Seventh Grade</NavLink>
               <NavLink to="/learning/eighthgrade_k8" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white  rounded-md' // Inactive styles
        }
      >Eighth Grade</NavLink>
               <NavLink to="/learning/ninethgrade_k9" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white  rounded-md' // Inactive styles
        }
      >Nineth Grade</NavLink>
               <NavLink to="/learning/tenthgrade_k10" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white  rounded-md' // Inactive styles
        }
      >Tenth Grade</NavLink>
               <NavLink to="/learning/eleventhgrade_k11" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white  rounded-md' // Inactive styles
        }
      >Eleventh Grade</NavLink>
               <NavLink to="/learning/twelvethgrade_k12" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white  rounded-md' // Active styles
            : 'text-white hover:bg-[#fbc901] hover:text-white  rounded-md' // Inactive styles
        }
      >Twelfth Grade</NavLink>


        {/*<Link to="/learning/alabama" className=' text-white text-lg flex'>Alabama</Link>
        <Link to="/learning/alaska" className='text-white text-lg flex'>Alaska</Link>
        <Link to="/learning/arizona" className=' text-white text-lg flex'>Arizona</Link>
        <Link to="/learning/arkansas" className=' text-white text-lg flex'>Arkansas</Link>
        <Link to="/learning/california" className=' text-white text-lg flex'>California</Link>
        <Link to="/learning/colorado" className=' text-white text-lg flex'>Colorado</Link>        
        <Link to="/learning/connecticut" className=' text-white text-lg flex'>Connecticut</Link>
        <Link to="/learning/delaware" className=' text-white text-lg flex'>Delaware</Link>
        <Link to="/learning/florida" className=' text-white text-lg flex'>Florida</Link>
        <Link to="/learning/georgia" className=' text-white text-lg flex'>Georgia</Link>
        <Link to="/learning/hawaii" className=' text-white text-lg flex'>Hawaii</Link>
        <Link to="/learning/idaho" className=' text-white text-lg flex'>Idaho</Link>
        <Link to="/learning/illinois" className=' text-white text-lg flex'>Illinois</Link>
        <Link to="/learning/indiana" className=' text-white text-lg flex'>Indiana</Link>
        <Link to="/learning/iowa" className=' text-white text-lg flex'>Iowa</Link>
        <Link to="/learning/kansas" className=' text-white text-lg flex'>Kansas</Link>
        <Link to="/learning/kentucky" className='text-white text-lg flex'>Kentucky</Link>
        <Link to="/louisiana" className=' text-white text-lg flex'>Louisiana</Link>
        <Link to="/learning/maine" className=' text-white text-lg flex'>Maine</Link>
        <Link to="/learning/maryland" className=' text-white text-lg flex'>Maryland</Link>
        <Link to="/learning/massachusetts" className=' text-white text-lg flex'>Massachusetts</Link>
        <Link to="/learning/michigan" className=' text-white text-lg flex'>Michigan</Link>
        <Link to="/learning/minnesota" className=' text-white text-lg flex'>Minnesota</Link>
        <Link to="/learning/mississippi" className=' text-white text-lg flex'>Mississippi</Link>
        <Link to="/learning/missouri" className=' text-white text-lg flex'>Missouri</Link>
        <Link to="/learning/montana" className=' text-white text-lg flex'>Montana</Link>
        <Link to="/learning/nebraska" className=' text-white text-lg flex'>Nebraska</Link>
        <Link to="/learning/nevada" className=' text-white text-lg flex'>Nevada</Link>
        <Link to="/learning/newhampshire" className=' text-white text-lg flex'>New Hampshire</Link>
        <Link to="/learning/newjersey" className=' text-white text-lg flex'>New Jersey</Link>
        <Link to="/learning/newyork" className=' text-white text-lg flex'>New York</Link>
        <Link to="/learning/newmexico" className='text-white text-lg flex'>New Mexico</Link>
        <Link to="/learning/northcarolina" className=' text-white text-lg flex'>North Carolina</Link>
        <Link to="/learning/northdakota" className=' text-white text-lg flex'>North Dakota</Link>
        <Link to="/learning/ohio" className=' text-white text-lg flex'>Ohio</Link>
        <Link to="/learning/oklahoma" className=' text-white text-lg flex'>Oklahoma</Link>
        <Link to="/learning/oregon" className=' text-white text-lg flex'>Oregon</Link>
        <Link to="/learning/pennsylvania" className=' text-white text-lg flex'>Pennsylvania</Link>
        <Link to="/learning/rhodeisland" className=' text-white text-lg flex'>Rhode Island</Link>
        <Link to="/learning/southcarolina" className=' text-white text-lg flex'>South Carolina</Link>
        <Link to="/learning/southdakota" className=' text-white text-lg flex'>South Dakota</Link>
        <Link to="/learning/tennessee" className=' text-white text-lg flex'>Tennessee</Link>
        <Link to="/learning/texas" className=' text-white text-lg flex'>Texas</Link>
        <Link to="/learning/utah" className=' text-white text-lg flex'>Utah</Link>
        <Link to="/learning/vermont" className=' text-white text-lg flex'>Vermont</Link>
        <Link to="/learning/virginia" className=' text-white text-lg flex'>Virginia</Link>
        <Link to="/learning/washington" className=' text-white text-lg flex'>Washington</Link>
        <Link to="/learning/westvirginia" className=' text-white text-lg flex'>West Virginia</Link>
        <Link to="/learning/wisconsin" className=' text-white text-lg flex'>Wisconsin</Link>
        <Link to="/learning/wyoming" className=' text-white text-lg flex'>Wyoming</Link> */}       
      </div>
    </div>
  );
}

export default Learning_us_states;
